import { Controller } from "stimulus"

export default class extends Controller {
  static targets = [ "issueBtn" ]

  issue(event) {
    this.issueBtnTarget.setAttribute("disabled", "true");

    $.post(this.element.dataset.issueUrl).then((data) => {
      this.element.outerHTML = data;
    }).catch((e) => {
      this.issueBtnTarget.setAttribute("disabled", "false");
      alert("Failed to load API key.\nPlease try again or contact support@remove.bg if the issue persists.")
    })
  }
}
